<div [ngClass]="{ 'center': true, 'flex-row': !isSmallScreen(), 'grid-column': isSmallScreen()}">
    <color-palette *ngFor="let percent of percents; let index=index" (click)="togglePercent(percent)"
        [text]="'D' + percent" [blurred]="!value.has(percent)" [color]="colors.get(percent)" [horizontal]="false" [small]="small">
    </color-palette>
</div>